export default "__VITE_ASSET__5898d587__"